import { LOYALTY_API_BASE } from "../../constants";
import { loyaltyFetch } from "../../hooks/loyaltyFetch";
import { segmentErrorMessage } from "./segmentErrorMessage";

/**
 * Parse GET /admin/segments/{id}/members response (see SEGMENTS_FRONTEND.md).
 */
export function parseMembersListResponse(data) {
    const items = Array.isArray(data?.items) ? data.items : (Array.isArray(data) ? data : []);
    return {
        items,
        total: Number.isFinite(data?.total) ? data.total : items.length,
        limit: data?.limit,
        offset: Number.isFinite(data?.offset) ? data.offset : 0,
        lastComputedAt: data?.last_computed_at ?? null,
        membershipStale: Boolean(data?.membership_stale),
        refreshed: Boolean(data?.refreshed),
        verified: Boolean(data?.verified),
        pageMismatchCount: Number.isFinite(data?.page_mismatch_count) ? data.page_mismatch_count : 0,
        note: data?.note ?? null,
    };
}

/**
 * @param {object} opts
 * @param {string} opts.segmentId - UUID moteur (jamais unomi_segment_id)
 * @param {string} opts.brandName
 * @param {number} [opts.limit]
 * @param {number} [opts.offset]
 * @param {boolean} [opts.refresh] - dynamique uniquement
 * @param {boolean} [opts.verify] - dynamique uniquement
 */
export async function fetchSegmentMembers({
    segmentId,
    brandName,
    limit = 100,
    offset = 0,
    refresh = false,
    verify = false,
}) {
    const params = new URLSearchParams({
        limit: String(limit),
        offset: String(offset),
    });
    if (refresh) params.set("refresh", "true");
    if (verify) params.set("verify", "true");

    const res = await loyaltyFetch(
        `${LOYALTY_API_BASE}/admin/segments/${segmentId}/members?${params}`,
        { headers: { "X-Brand": brandName } },
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        const ctx = refresh ? "refresh" : undefined;
        throw new Error(segmentErrorMessage(res.status, data?.detail, "Liste des membres", ctx));
    }
    return parseMembersListResponse(data);
}
